import React from "react"
export function LeftChevron(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <g
        id="prefix__left-chevron"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <path
          d="M5.71 9.48a.75.75 0 00-.076.948l.075.091 6.717 6.981 1.074-1.039L7.283 10 13.5 3.54 12.426 2.5 5.71 9.48z"
          id="prefix__left"
          fill="currentColor"
          fillRule="nonzero"
        />
      </g>
    </svg>
  )
}
